import { useQuery } from "@tanstack/react-query";

import { getCropExplorationTemplates, getCropExplorations } from "services";

import { GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES } from "consts";

import { CropExplorationResponse, CropExplorationTemplateResponse, User } from "models";

export const useGetCropExploration = ({ user, pseudoUserId, isAdmin = false }: { user: User | null; pseudoUserId: string | null; isAdmin?: boolean }) =>
  useQuery<CropExplorationResponse[] | CropExplorationTemplateResponse[] | []>({
    queryKey: [GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES, isAdmin, pseudoUserId, user],
    queryFn: ({ signal }) => {
      if (isAdmin) {
        return getCropExplorationTemplates(signal);
      }
      if (user || pseudoUserId) {
        return getCropExplorations(pseudoUserId, signal);
      }

      return [];
    },
  });
